import { JsonProperty, deserialize } from 'json-typescript-mapper';
import { Auth as IAuth } from './interfaces/auth.interface';
import { UserInterface as IUser } from './interfaces/user.interface';

export const initialState: IAuth = {
  user: {},
  name: '',
  email: '',
  apiToken: '',
}

export class Auth {
  public user: IUser;
  public name: string;
  public email: string;
  @JsonProperty("api_token")
  public apiToken: string;

	/**
	* Constructs a new Auth object merged with initialState and passed input. Supports mapped types
	* @param init
	*/
  constructor(init?: Partial<IAuth>) {
    // Assign this, args and initialState of make sure all properties are available on creation
    Object.assign(this, initialState, init);
  }

	/**
	* Creates a new instance of this object type based on given data merged with initialState
	* @param data - A json version of the object type
	*/
  public static create(data: IAuth): Auth {
    return deserialize(Auth, data);
  }
}



// WEBPACK FOOTER //
// ./src/models/auth.model.ts